import React, { FC, useState, useEffect } from 'react';

import Grid from '@mui/material/Grid';

import BackflowDeviceDisplay from './BackflowDeviceDisplay';
import BackflowDeviceEdit from './BackflowDeviceEdit';
import BeginTestButton from './BeginTestButton';

import { backflowJobItemRequiredFields } from '../../backflowJobLists/constants/requiredFields';
import validateRequiredFields from '../../../utils/validateRequiredFields';

import { BackflowJobItem } from '../../model';

interface JobItemSectionProps {
  backflowJobItem: BackflowJobItem;
  fetchBackflowJobItem: () => void;
  jobStarted: boolean;
}

const JobItemSection: FC<JobItemSectionProps> = ({ backflowJobItem, fetchBackflowJobItem, jobStarted }) => {
  const [editingDeviceDetails, setEditingDeviceDetails] = useState<boolean>(false);

  useEffect(() => {
    if (backflowJobItem?.id) {
      const { isValid } = validateRequiredFields(backflowJobItem, backflowJobItemRequiredFields);
      if (!isValid) setEditingDeviceDetails(true);
    }
  }, [backflowJobItem]);

  const handleSave = () => {
    setEditingDeviceDetails(false);
    fetchBackflowJobItem();
  };

  const handleCancel = () => {
    setEditingDeviceDetails(false);
  };

  const handleEdit = () => {
    setEditingDeviceDetails(true);
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        {editingDeviceDetails ? (
          <BackflowDeviceEdit backflowJobItem={backflowJobItem} onSave={handleSave} onCancel={handleCancel} />
        ) : (
          <BackflowDeviceDisplay backflowJobItem={backflowJobItem} onEdit={handleEdit} />
        )}
      </Grid>

      {!jobStarted && !editingDeviceDetails && (
        <Grid item xs={12}>
          <BeginTestButton backflowJobItem={backflowJobItem} onSuccess={fetchBackflowJobItem} />
        </Grid>
      )}
    </Grid>
  );
};

export default JobItemSection;
